import getConfiguration from 'config/configuration';

const Config = getConfiguration(window.location);

export default Config;
